export enum TransmissionStatus {
  INIT,
  STOP,
  RUNNING,
  DISCONNECT,
  MIC,
  FM,
  SCHEDULE_OFFLINE,
  MEETING,
  MAT_NGUON,
  LOA_HO_MACH,
}

export const mapTransmissionStatus = new Map<
  number,
  {label: string; value: TransmissionStatus; color: string; bgColor: string}
>([
  [
    TransmissionStatus.INIT,
    {
      label: 'Chờ phát',
      value: TransmissionStatus.INIT,
      color: 'rgb(245 170 27)',
      bgColor: 'rgb(255 253 232)',
    },
  ],
  [
    TransmissionStatus.STOP ||
      TransmissionStatus.DISCONNECT ||
      TransmissionStatus.MIC ||
      TransmissionStatus.FM ||
      TransmissionStatus.SCHEDULE_OFFLINE ||
      TransmissionStatus.MAT_NGUON ||
      TransmissionStatus.LOA_HO_MACH,
    {
      label: 'Không phát',
      value: TransmissionStatus.STOP,
      color: 'rgb(245, 34, 27)',
      bgColor: 'rgb(255 253 232)',
    },
  ],
  [
    TransmissionStatus.RUNNING || TransmissionStatus.MEETING,
    {label: 'Đang phát', value: TransmissionStatus.RUNNING, color: '#2E1C32', bgColor: '#E5EBEE'},
  ],
])
